import { render, staticRenderFns } from "./TrailCategory.vue?vue&type=template&id=48672989&scoped=true"
import script from "./TrailCategory.vue?vue&type=script&lang=js"
export * from "./TrailCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48672989",
  null
  
)

export default component.exports